class ShippingLabelController {
    static $inject = ["$q", "$location", "$sce", "stToast", "tpsrService", "reportService"];

    constructor($q, $location, $sce, stToast, tpsrService, reportService) {
        this.$q = $q;
        this.$location = $location;
        this.$sce = $sce;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.reportService = reportService;
        this.label = null;
    }

    $onInit() {
        return this._loadLabel();
    }


    _loadLabel = () => {
        return this.tpsr.getShippingLabel(this.returnId).then(l => this.label = "data:image/gif;base64," + l);
    };
}

angular
    .module("app")
    .component("shippingLabel", { // shipping-label
        bindings: {
            returnId: "<"
        },
        templateUrl: "src/app/shippingLabel/shippingLabel.html",
        controller: ShippingLabelController
    });
